import React, { useState } from "react";
import classnames from "classnames";

import styles from "./AudioPlayerBlock.module.scss";
import { AudioBlockView } from "@src/lms/jelly/extensions/blocks/audio/AudioBlockView";

export interface AudioPlayerProps {
  samples: Array<{
    title: string;
    src: string;
  }>;
  autoplayOnTrackSwitch?: boolean;
  autoplay?: boolean;
  reversePlayer?: boolean;
}

export const AudioPlayerBlock: React.FC<AudioPlayerProps> = ({
  samples,
  autoplay: autoplayOnInit,
  autoplayOnTrackSwitch,
  reversePlayer,
}) => {
  const [activeSample, setActiveSample] = useState(samples![0]);
  const [autoplay, setAutoplay] = useState(autoplayOnInit ?? false);

  const handleSampleSwitch = (index: number): void => {
    setAutoplay(autoplayOnTrackSwitch ?? false);
    setActiveSample(samples[index]);
  };

  return (
    <div className={styles.root}>
      <AudioBlockView
        src={activeSample.src}
        autoplay={autoplay}
        reverse={reversePlayer || false}
        key={activeSample.src}
        styles={{ height: "100px", border: 0 }}
      />
      <div className={styles.list}>
        {samples.map((sample, index) => (
          <div
            key={sample.src}
            className={classnames(styles.listItem, {
              [styles.active]: sample.src === activeSample.src,
            })}
            onClick={() => handleSampleSwitch(index)}
          >
            {sample.title}
          </div>
        ))}
      </div>
    </div>
  );
};
